import styled, { keyframes } from "styled-components";
import { useIntl } from "gatsby-plugin-intl";

import { Provinces, useProvince } from "../state/ProvinceProvider";
import { fixPropWarnings } from "../utils/fixPropWarnings";
import BlackTriangleDown from '../images/black-triangle-icon-down.svg';

export const StyledSelect = styled.select`
  padding: 0.2em;
  padding-right: 1em;
  margin: 0 0.2em;
  font-size: 1rem;
  font-weight: 400;
  text-align: center;
  text-transform: uppercase;
  background: url(${BlackTriangleDown}) no-repeat transparent;
  background-size: 0.4em;
  background-position: center right 0.2em;
`;

const pulse = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
`;

interface SkeletonProps{
  width: string;
}

const SkeletonTextLine = styled.div.withConfig(fixPropWarnings('width'))<SkeletonProps>`
  width: ${(props: { width: string }) => props.width};
  height: 1.1em;
  background-color: #e0e0e0;
  animation: 1.5s ease-in-out 0.25s infinite normal none running ${pulse};
  border-radius: 4px;
`;

const ProvinceSelector = () => {
  const onProvinceChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedProvince = event.currentTarget.value;
    setActiveProvince(selectedProvince as Provinces);
  };
  const { activeProvince, setActiveProvince, provinceOverride } = useProvince();
  const { locale } = useIntl();
  return (
    <div data-testid="ProvinceSelector">
      {activeProvince ? (
        <StyledSelect
          aria-label={locale === "fr" ? "Sélecteur de province" : "Province Selector"}
          value={activeProvince}
          onChange={onProvinceChange}
          data-testid="province-select"
          disabled={!!provinceOverride}
        >
          {Object.values(Provinces).map(
            prov => <option key={prov} value={prov}>{prov}</option>,
          )}
        </StyledSelect>
      )
        : <SkeletonTextLine width="30px" />}
    </div>
  );
};

export default ProvinceSelector;
